import { Link } from 'react-router-dom'
import React from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import OffcanvasBody from 'react-bootstrap/OffcanvasBody'
import axios from 'axios';

function Sidebar(props) {
    const handleClose = () => {
        props.onChildOffcanClose(false);
    }

    const handleExportUser = () => {
        axios({
            url: 'api/export/user/excel',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'users.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    const handlePbalanceReport = () => {
        axios({
            url: 'api/pbalance',
            method: 'get',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            window.open(url, '_blank');
            handleClose();
        });
    }

    const handleOverallRecievableBySalesman = () => {
        axios({
            url: 'api/overallrecievablebysalesman',
            method: 'get',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            window.open(url, '_blank');
            handleClose();
        });
    }

    // Navigation link component for cleaner code
    const NavLink = ({ to, onClick, children, className = '', isExport = false }) => {
        if (isExport) {
            return (
                <span 
                    onClick={onClick} 
                    className={`nav-link-item ${className}`}
                >
                    {children}
                </span>
            );
        }
        return (
            <Link 
                to={to} 
                onClick={onClick} 
                className={`nav-link-item ${className}`}
            >
                {children}
            </Link>
        );
    }

    return (
        <div>
            <Offcanvas 
                show={props.show} 
                className='sidebar-offcanvas animated fadeInDown' 
                onHide={handleClose} 
                placement='end' 
                scroll='false'
            >
                <Offcanvas.Header closeButton className="sidebar-header">
                    <Offcanvas.Title className="sidebar-title">
                        <span className="title-icon">📊</span> Reports & Management
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <OffcanvasBody className="sidebar-body">
                    <Accordion className="sidebar-accordion">
                        {/* Reports Section */}
                        <Accordion.Item eventKey="8" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">📋</span> Reports
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='/allsaleinvoices' onClick={handleClose}>📄 All Sale Invoices</NavLink>
                                <NavLink to='/alldeletedsaleinvoices' onClick={handleClose}>🗑️ All Deleted Sale Invoices</NavLink>
                                <NavLink to='dailyinvoicessummery' onClick={handleClose}>📊 Daily Invoices Summary</NavLink>
                                <NavLink to='batchlistinvoices' onClick={handleClose} className="hidden-link">📦 Batch List Invoices</NavLink>
                                <NavLink to='allinvoiceview' onClick={handleClose}>👁️ Bulk Invoices View</NavLink>
                                <NavLink to='/gstcustomerreport' onClick={handleClose}>🧾 Customers GST Tax</NavLink>
                                <NavLink to='all/purchase/invoices' onClick={handleClose}>🛒 All Purchase Invoices</NavLink>
                                <NavLink to='/dailybrandsalereport' onClick={handleClose}>📈 Daily Sale Report</NavLink>
                                <NavLink isExport={true} onClick={handleExportUser}>📤 Export Users Detail In Excel</NavLink>
                                <NavLink to='stockbystore' onClick={handleClose}>📦 Closing Stock</NavLink>
                                <NavLink to='salesummerybybrand' onClick={handleClose}>💰 Profit Report By Sale</NavLink>
                                <NavLink to='pointscheme' onClick={handleClose}>⭐ Point Scheme</NavLink>
                                <NavLink to='stockstatus' onClick={handleClose}>📊 Stock Status</NavLink>
                                <NavLink to='ledger' onClick={handleClose}>📒 Client Ledger</NavLink>
                                <NavLink to='duelist' onClick={handleClose}>💳 Due/Recovery List</NavLink>
                                <NavLink isExport={true} onClick={handlePbalanceReport}>🏦 Overall Receivable By Customer</NavLink>
                                <NavLink isExport={true} onClick={handleOverallRecievableBySalesman}>👤 Overall Receivable By Salesman</NavLink>
                                <NavLink to='sectorsalepbalance' onClick={handleClose}>🌍 Region Sale With Previous Balance</NavLink>
                                <NavLink to='subsectorsalepbalance' onClick={handleClose}>📍 Location Sale With Previous Balance</NavLink>
                                <NavLink to='/due/sector/report' onClick={handleClose}>🌍 Region Due Report</NavLink>
                                <NavLink to='/brand/purchase/report' onClick={handleClose}>📊 Purchase Report</NavLink>
                                <NavLink to='/monthlyexpensereport' onClick={handleClose}>📅 Monthly Expense Report</NavLink>
                                <NavLink to='showstockdayclose' onClick={handleClose}>📆 Show Day Closing</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Registration Module */}
                        <Accordion.Item eventKey="0" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">👤</span> Registration Module
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='/userslist' onClick={handleClose}>➕ Add Users</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Bank Detail */}
                        <Accordion.Item eventKey="1" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">🏦</span> Bank Detail
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='openingbalance' onClick={handleClose}>💰 Add Opening Balance</NavLink>
                                <NavLink to='recievepayment' onClick={handleClose}>💵 Receive Payments</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Company Detail */}
                        <Accordion.Item eventKey="2" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">🏢</span> Company Detail
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='systemstore' onClick={handleClose}>🏪 Add Store</NavLink>
                                <NavLink to='systeminvoice' onClick={handleClose}>📄 Add Invoice Detail</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Location Detail */}
                        <Accordion.Item eventKey="3" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">📍</span> Location Detail
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='addsector' onClick={handleClose}>🌍 Add Region</NavLink>
                                <NavLink to='addsubsector' onClick={handleClose}>🏙️ Add City</NavLink>
                                <NavLink to='assignsector' onClick={handleClose}>📌 Assign City To Customer</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Products Management */}
                        <Accordion.Item eventKey="4" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">📦</span> Products Management
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to="/add/category" onClick={handleClose}>📂 Add Category</NavLink>
                                <NavLink to='/add/product' onClick={handleClose}>🛍️ Add Product</NavLink>
                                <NavLink to='/gen/barcode' onClick={handleClose}>🔲 Generate Barcode</NavLink>
                                <NavLink to='/import/products' onClick={handleClose}>📥 Import Product</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Purchase Management */}
                        <Accordion.Item eventKey="6" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">🛒</span> Purchase Management
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='/purchase/entry/invoice' onClick={handleClose}>➕ Add Purchase Invoice</NavLink>
                                <NavLink to='all/purchase/invoices' onClick={handleClose}>📋 All Purchase Invoices</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Special Invoices */}
                        <Accordion.Item eventKey="7" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">⭐</span> Special Invoices
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='autoname' onClick={handleClose}>📝 Special Invoice Names</NavLink>
                                <NavLink to='settingautoname' onClick={handleClose}>⚙️ Setting Special Invoice</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* Expense Sheet */}
                        <Accordion.Item eventKey="9" className="accordion-custom">
                            <Accordion.Header className="accordion-header-custom">
                                <span className="accordion-icon">💸</span> Expense Sheet
                            </Accordion.Header>
                            <Accordion.Body className="accordion-body-custom">
                                <NavLink to='/expensesheet' onClick={handleClose}>📊 Add Monthly Expense</NavLink>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </OffcanvasBody>
            </Offcanvas>

            <style jsx>{`
                /* Sidebar Container */
                .sidebar-offcanvas {
                    width: 380px !important;
                    background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%) !important;
                    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.12) !important;
                    border-left: 4px solid #4a90e2 !important;
                }

                /* Header Styling */
                .sidebar-header {
                    background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%) !important;
                    padding: 20px 24px !important;
                    border-bottom: 3px solid #2d6da8 !important;
                }

                .sidebar-title {
                    color: white !important;
                    font-weight: 700 !important;
                    font-size: 1.3rem !important;
                    letter-spacing: 0.5px !important;
                    display: flex !important;
                    align-items: center !important;
                    gap: 10px !important;
                }

                .title-icon {
                    font-size: 1.6rem !important;
                }

                /* Close Button Customization */
                .sidebar-header .btn-close {
                    filter: brightness(0) invert(1) !important;
                    opacity: 0.8 !important;
                    transition: all 0.3s ease !important;
                }

                .sidebar-header .btn-close:hover {
                    opacity: 1 !important;
                    transform: rotate(90deg) !important;
                }

                /* Body Styling */
                .sidebar-body {
                    padding: 12px 8px !important;
                    background: #f8f9fa !important;
                }

                /* Accordion Customization */
                .sidebar-accordion {
                    --bs-accordion-border-color: transparent !important;
                    --bs-accordion-btn-bg: transparent !important;
                    --bs-accordion-active-bg: transparent !important;
                    --bs-accordion-btn-padding-y: 12px !important;
                    --bs-accordion-btn-padding-x: 16px !important;
                }

                .accordion-custom {
                    border: none !important;
                    margin-bottom: 6px !important;
                    background: transparent !important;
                }

                .accordion-header-custom {
                    background: white !important;
                    border-radius: 10px !important;
                    padding: 6px 0 !important;
                    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.08) !important;
                    transition: all 0.3s ease !important;
                    font-weight: 600 !important;
                    color: #2c3e50 !important;
                }

                .accordion-header-custom:hover {
                    background: #f0f4ff !important;
                    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.15) !important;
                    transform: translateX(4px) !important;
                }

                .accordion-header-custom .accordion-button {
                    background: transparent !important;
                    color: #2c3e50 !important;
                    font-weight: 600 !important;
                    padding: 8px 16px !important;
                    border-radius: 10px !important;
                    box-shadow: none !important;
                }

                .accordion-header-custom .accordion-button:not(.collapsed) {
                    background: transparent !important;
                    color: #4a90e2 !important;
                    box-shadow: none !important;
                }

                .accordion-header-custom .accordion-button::after {
                    background-size: 0.8rem !important;
                    transition: all 0.3s ease !important;
                }

                .accordion-icon {
                    margin-right: 10px !important;
                    font-size: 1.1rem !important;
                }

                .accordion-body-custom {
                    background: white !important;
                    border-radius: 0 0 10px 10px !important;
                    padding: 8px 4px !important;
                    margin-top: 2px !important;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
                }

                /* Navigation Links */
                .nav-link-item {
                    display: block !important;
                    padding: 10px 20px !important;
                    margin: 4px 8px !important;
                    color: #34495e !important;
                    text-decoration: none !important;
                    border-radius: 8px !important;
                    font-size: 0.95rem !important;
                    font-weight: 500 !important;
                    transition: all 0.25s ease !important;
                    cursor: pointer !important;
                    background: transparent !important;
                    border-left: 3px solid transparent !important;
                    letter-spacing: 0.3px !important;
                }

                .nav-link-item:hover {
                    background: linear-gradient(135deg, #e8f0fe 0%, #d4e4f7 100%) !important;
                    border-left-color: #4a90e2 !important;
                    transform: translateX(6px) !important;
                    color: #2c3e50 !important;
                    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.12) !important;
                }

                .nav-link-item:active {
                    transform: scale(0.98) !important;
                }

                /* Hide specific link */
                .hidden-link {
                    display: none !important;
                }

                /* Divider styling (replacing <hr> with CSS) */
                .nav-link-item:not(:last-child)::after {
                    content: '' !important;
                    display: block !important;
                    height: 1px !important;
                    background: linear-gradient(to right, transparent, #e0e7ef, transparent) !important;
                    margin: 8px 0 4px 0 !important;
                }

                /* Scrollbar customization */
                .sidebar-body::-webkit-scrollbar {
                    width: 6px !important;
                }

                .sidebar-body::-webkit-scrollbar-track {
                    background: #f1f1f1 !important;
                    border-radius: 10px !important;
                }

                .sidebar-body::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #4a90e2, #357abd) !important;
                    border-radius: 10px !important;
                }

                .sidebar-body::-webkit-scrollbar-thumb:hover {
                    background: #2d6da8 !important;
                }

                /* Responsive adjustments */
                @media (max-width: 576px) {
                    .sidebar-offcanvas {
                        width: 100% !important;
                    }
                    
                    .nav-link-item {
                        padding: 8px 16px !important;
                        font-size: 0.9rem !important;
                    }
                    
                    .sidebar-title {
                        font-size: 1.1rem !important;
                    }
                }

                /* Animation enhancement */
                .animated {
                    animation-duration: 0.4s !important;
                }

                .fadeInDown {
                    animation-name: fadeInDown !important;
                }

                @keyframes fadeInDown {
                    from {
                        opacity: 0;
                        transform: translate3d(0, -20px, 0);
                    }
                    to {
                        opacity: 1;
                        transform: translate3d(0, 0, 0);
                    }
                }

                /* Accordion item border removal */
                .accordion-item:last-of-type .accordion-button.collapsed {
                    border-bottom-right-radius: 10px !important;
                    border-bottom-left-radius: 10px !important;
                }

                .accordion-item:first-of-type .accordion-button {
                    border-top-left-radius: 10px !important;
                    border-top-right-radius: 10px !important;
                }

                /* Bootstrap overrides */
                .offcanvas-header .btn-close {
                    margin-right: 0 !important;
                }
            `}</style>
        </div>
    )
}

export default Sidebar